<template>
  <TemplatePageGrid :items="grid" :page-data="pageData">
    <template v-slot:buttons>
      <BaseButton
        v-if="$userCheckAccess({ abilities: $route.name.includes('Sales') ? 'edit_invoicing_companies' : 'edit_clients' })"
        :text="localStorage.translations.pages['setting-client']['dialog-add_edit-buttons']['dobavit']"
        default_icon="button-add"
        @click="$router.push({name: $route.name + 'Create'})"
      />
    </template>
    <WorkClientTable>
      <WorkClientTableItem
        v-for="item in grid"
        :key="item.id"
        :item="item"
        :open-name="$route.name + 'Show'"
        :on-delete="onDeleteItem"
      />
    </WorkClientTable>
  </TemplatePageGrid>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import WorkClientTable from "components/workClient/WorkClientTable";
import WorkClientTableItem from "components/workClient/WorkClientTableItem";

export default {
  name: "clientsList",
  components: {WorkClientTableItem, WorkClientTable},
  computed: {
    ...mapGetters('workClient', {
      companyGrid: 'workClientGrid',
      companyPageData: 'pageData'
    }),
    ...mapGetters('workClientInvoicingCompany', {
      companySalesGrid: 'workClientInvoicingCompanyGrid',
      companySalesPageData: 'pageData'
    }),
    type() {
      return this.$route.name === 'clientsCompany' ? 'company' : 'companySales'
    },
    grid() {
      return this[this.type + 'Grid']
    },
    pageData() {
      return this[this.type + 'PageData']
    }
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  created() {
    this.downloadPageData()
  },
  methods: {
    ...mapActions('workClient', ['onWorkClientGrid', 'onWorkClientDelete']),
    ...mapActions('workClientInvoicingCompany',
      ['onWorkClientInvoicingCompanyGrid', 'onWorkClientInvoicingCompanyDelete']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value)
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      if (this.$route.query.search)
        data.search = this.$route.query.search
      if (this.type === 'company')
        this.onWorkClientGrid(data)
      else
        this.onWorkClientInvoicingCompanyGrid(data)
    },
    async onDeleteItem(id) {
      if (this.type === 'company')
        await this.onWorkClientDelete(id)
          .then(() => {
            this.downloadPageData()
          })
      else
        await this.onWorkClientInvoicingCompanyDelete(id)
          .then(() => {
            this.downloadPageData()
          })
    }
  }
}
</script>